export default {"src":"/_next/static/media/chicken.d60b2c90.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};